import React from 'react';
import { Logo } from './CoazIcons';
import { 
  BsEnvelopeFill, 
  BsFillTelephoneFill, 
  BsClockFill 
} from "react-icons/bs";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaPaperPlane, FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { FaLocationDot, FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  return (
    <div className='relative flex flex-col shrink-0 w-full bg-white'>
      
      {/* Main Footer Content */}
      <div className='flex flex-col lg:flex-row px-[5%] items-center justify-between w-full min-h-[500px] text-[rgba(200,200,200)] bg-[rgb(20,20,20)] py-16 lg:py-20 gap-8 lg:gap-12'>
        
        {/* Logo */}
        <div className='flex flex-col items-center lg:items-start w-full lg:w-[15%] space-y-6 mb-8 lg:mb-0'>
          <Logo size={80} fill='rgba(150, 150, 150)' className='mx-auto lg:mx-0'/>
        </div>
        <div className='flex flex-col lg:flex-row justify-between w-full'>
        {/* Contact Information */}
        <div className='flex flex-col w-full lg:w-[30%] space-y-4 mb-8 lg:mb-0'>
          <div className='flex flex-col space-y-2'>
            <p className=' text-lg font-leBeauneNew font-semibold'>Contacts</p>
            <div className='flex flex-col space-y-3'>
              <div className='flex flex-row space-x-4  transition-colors duration-300'>
                <BsEnvelopeFill size={16} className='my-auto shrink-0'/>
                <p className='my-auto text-sm tracking-wider font-jostBook'>info@coaz.com</p>
              </div>
              <div className='flex flex-row space-x-4 transition-colors duration-300'>
                <BsFillTelephoneFill size={16} className='my-auto shrink-0'/>
                <p className='my-auto text-sm tracking-wider font-jostBook'>+260761234390</p>
              </div>
              <div className='flex flex-row space-x-4 transition-colors duration-300'>
                <IoLogoWhatsapp size={16} className='my-auto shrink-0'/>
                <p className='my-auto text-sm tracking-wider font-jostBook'>+260761234390</p>
              </div>
              <div className='flex flex-row space-x-4 transition-colors duration-300'>
                <FaPaperPlane size={16} className='my-auto shrink-0'/>
                <p className='my-auto text-sm tracking-wider font-jostBook'>P.O Box 12345</p>
              </div>
            </div>
          </div>
        </div>

        {/* Location */}
        <div className='flex flex-col w-full lg:w-[30%] space-y-4 mb-8 lg:mb-0'>
          <div className='flex flex-col space-y-2'>
            <p className='text-lg font-leBeauneNew font-semibold'>Location</p>
            <div className='flex flex-row space-x-4 transition-colors duration-300'>
              <FaLocationDot size={16} className='my-auto shrink-0'/>
              <p className='my-auto text-sm tracking-wider font-jostBook'>
                House No. 22(01) MKP, Wezi Kaunda Road, PHI, Lusaka, Zambia
              </p>
            </div>
          </div>
        </div>

        {/*Work Hours */}
        <div className='flex flex-col w-full lg:w-[22%] space-y-4'>
          <div className='flex flex-col space-y-2'>
            <p className='text-lg font-leBeauneNew font-semibold'>Work Hours</p>
            <div className='flex flex-col space-y-3'>
              <div className='flex flex-row space-x-4  transition-colors duration-300'>
                <BsClockFill size={16} className='my-auto shrink-0'/>
                <p className='my-auto text-sm tracking-wider font-jostBook'>Week days: 08:00 - 17:00</p>
              </div>
              {/* <div className='flex flex-row space-x-4  transition-colors duration-300'>
                <BsClockFill size={16} className='my-auto shrink-0'/>
                <p className='my-auto text-sm tracking-wider font-jostBook'>Weekends: 08:00 - 12:00</p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      </div>
      {/* Social Media Icons */}
      <div className='flex flex-row justify-center lg:justify-end items-center w-full text-[rgba(200,200,200)] bg-[rgb(20,20,20)] px-[5%] py-3'>
        <div className='flex flex-row space-x-6'>
          <FaFacebookF 
            size={22} 
            className='cursor-pointer  hover:text-[#1877f2] hover:scale-125 transition-all duration-300' 
          />
          <FaLinkedinIn 
            size={22} 
            className='cursor-pointer  hover:text-[#0a66c2] hover:scale-125 transition-all duration-300' 
          />
          <FaXTwitter 
            size={22} 
            className='cursor-pointer  hover:text-[#1da1f2] hover:scale-125 transition-all duration-300' 
          />
          <FaInstagram 
            size={22} 
            className='cursor-pointer  hover:text-[#e4405f] hover:scale-125 transition-all duration-300' 
          />
        </div>
      </div>
    
      {/* Copyright Container */}
      <div className='flex flex-col lg:flex-row justify-center items-center w-full h-auto bg-[rgb(30,30,30)] lg:h-14 px-[5%] py-3 lg:py-0 text-sm text-white tracking-wider font-jostLight'>
        <p className='lg:my-auto mb-2 lg:mb-auto text-center lg:text-left text-[rgba(255,255,255,.85)]'>
          Copyright All Right Reserved 2024, Coaz
        </p>
        {/* <p className='lg:my-auto text-center lg:text-right text-[rgba(255,255,255,.7)] text-xs'>
          Designed by Stometech Solutions
        </p> */}
      </div>
    </div>
  );
};

export default Footer;